import React, { useEffect, useState } from "react";
import Popup from "reactjs-popup";
import "reactjs-popup/dist/index.css";
import Styles from "./styles.module.scss";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";

import TwoFactorCodeInput from "../../_UI/twoFactorCodeInput";

import {
    disable2fa,
    getProfileMainData,
    setCabinetProfileDisableTwoFactorModalStatus
} from "../../../store/cabinet/action";

const CODE_LENGTH = 6;

const CabinetProfileDisableTwoFactorModal = () => {
    const dispatch = useDispatch();
    const { t } = useTranslation();

    const modalStatus = useSelector(store => store.cabinet.cabinetProfileDisableTwoFactorModalStatus);
    const disable2faStarted = useSelector(store => store.cabinet.disable2faStarted);
    const disable2faErr = useSelector(store => store.cabinet.disable2faErr);

    const [verificationCode, setVerificationCode] = useState("");

    const isSubmitDisabled =
        disable2faStarted ||
        verificationCode.length !== CODE_LENGTH;

    const closeModal = () => {
        if (disable2faStarted) return;

        dispatch(setCabinetProfileDisableTwoFactorModalStatus(false));
    };

    const successHandler = () => {
        toast(t("Двухфакторная аутентификация отключена"));
        closeModal();

        dispatch(getProfileMainData());
    };

    const disableHandler = () => {
        if (isSubmitDisabled) return;

        const payload = {
            code: verificationCode,
        };

        dispatch(disable2fa(payload, successHandler));
    };

    useEffect(() => {
        if (modalStatus) {
            setVerificationCode("");
        }
    }, [modalStatus]);

    return (
        <Popup
            open={!!modalStatus}
            modal
            nested
            closeOnDocumentClick={!disable2faStarted}
            onClose={closeModal}
            className="cabinetProfileDisableTwoFactorModal"
        >
            <div className={Styles.modalContainer}>
                <div
                    className={`
                        ${Styles.modalCloseBtn}
                        ${disable2faStarted ? Styles.modalCloseBtnDisabled : ""}
                    `}
                    onClick={closeModal}
                >
                    <div />
                    <div />
                </div>

                <div className={Styles.modalContentWrap}>
                    <div className={Styles.titleRow}>
                        <div className={Styles.titleIcon}>
                            <span>!</span>
                        </div>

                        <div className={Styles.titleTextWrap}>
                            <div className={Styles.title}>
                                {t("Отключение 2FA")}
                            </div>

                            <div className={Styles.note}>
                                {t("Подтвердите действие кодом из приложения-аутентификатора.")}
                            </div>
                        </div>
                    </div>

                    <div className={Styles.warningBox}>
                        <div className={Styles.warningTitle}>
                            {t("Вы отключаете дополнительную защиту аккаунта")}
                        </div>

                        <div className={Styles.warningText}>
                            {t("После отключения 2FA для входа и важных операций больше не будет запрашиваться одноразовый код. Это снижает уровень защиты аккаунта, особенно если пароль будет скомпрометирован.")}
                        </div>
                    </div>

                    <TwoFactorCodeInput
                        value={verificationCode}
                        onChange={setVerificationCode}
                        formErr={disable2faErr}
                        errorFieldName="code"
                        isLoading={disable2faStarted}
                        label="Код аутентификации"
                        hint="Введите код, который сейчас отображается в приложении."
                    />

                    <div className={Styles.actionsRow}>
                        <button
                            type="button"
                            className={Styles.cancelBtn}
                            onClick={closeModal}
                            disabled={disable2faStarted}
                        >
                            {t("Отмена")}
                        </button>

                        <button
                            type="button"
                            className={Styles.disableBtn}
                            onClick={disableHandler}
                            disabled={isSubmitDisabled}
                        >
                            {disable2faStarted ? t("Отключение") : t("Отключить 2FA")}
                        </button>
                    </div>
                </div>
            </div>
        </Popup>
    );
};

export default CabinetProfileDisableTwoFactorModal;
